import { ref } from 'vue'
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import FileUpload from '@/components/file-upload'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import historiqueApi from '@/api/consultations/_historique-consultation'
import consultationApi from '@/api/_consultation'
import { synthese_redigee } from '@/utils/resume-consultation-print'
import $ from 'jquery'
import KineSectionFields from '@/components/kine-section-fields.vue'
import { kineSection, initializeKineFields, clinicNow } from '@/utils/kine-section-fields'

export default {
    name: 'manage-section-form',
    inject: { kineContext: { default: () => ({ fuseau: '' }) } },
    components: {
        VueEditor, FileUpload, KineSectionFields
    },
    props: {
        enregistrer_rubrique: Function,
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_patient: {
            type: Object,
            default: () => ({})
        },
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        selected_content: {
            type: Array,
            default: () => ([])
        },
        data_to_be_deleted: {
            type: Object,
            default: () => ({})
        },
        slug: String,
        liste_champs: Array,
        section_name: String,
        patient: { type: Object, default: () => ({}) },
        consultation: { type: Object, default: () => ({}) },
    },

    data() {
        return {
            customToolbar: [
                ...vueEditorToolbar,
                ['blockquote', 'code-block'],
                [{ script: 'sub' }, { script: 'super' }],
                ['link', 'clean']
            ],
            save_loading: false,
            err_message: '',
            is_loading: true,
            adm_is_loading: true,
            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            d_date: ref(new Date().toISOString().split('T')[0]),

            section_data: {
                v_model: []
            },

            selected_champ: [],
            o_occurence: [],
            filtered_occurence: [],

            can_show_micro: [],
            is_recording: ref(false),

            recognition: null,
            transcript: '',
            is_listening: false,
            recognition_err_msg: '',
            active_dictation_index: null,
            dictee_tentative: 0,
            tables_by_field: {},
            synthese_loading: false,
            synthese_error: '',
            synthese_source_date: '',
            synthese_initiale: ''
        }
    },

    watch : {
        grs_toggler() {
            this.initFields()
            this.getListeAdmissions()
            this.$store.dispatch("getListeOccurences")
        }
    },

    computed: {
        isKineSection() { return !!kineSection(this.slug) },
        hasRichEditor() {
            return Array.isArray(this.liste_champs) && this.liste_champs.some(c => c.type_champ === 'Editeur de texte')
        },

        liste_occurences() {
            return this.$store.getters["liste_occurences"];
        },

        liste_adimissions() {
            return this.$store.getters["liste_adimissions"];
        },
    },

    mounted() {
        $(this.$refs.mdl_section_form).on('hidden.bs.modal', this.stopRecording)
    },

    beforeDestroy() {
        $(this.$refs.mdl_section_form).off('hidden.bs.modal', this.stopRecording)
        if (this.is_listening) this.stopRecording()
    },

    methods: {
        async genererSyntheseIa() {
            const editor = this.section_data.v_model.find(field => field.type === 'Editeur de texte')
            if (!editor || !String(editor.value || '').trim()) {
                this.synthese_error = 'Renseignez d’abord le brouillon médical à améliorer.'
                return false
            }
            if (!window.confirm('Envoyer le brouillon clinique pseudonymisé à Gemini sur Google Cloud Vertex AI pour reformulation ? Vérifiez qu’il ne contient pas d’identifiants de personnes. Le texte actuel sera remplacé uniquement dans l’éditeur, sans enregistrement automatique.')) return false
            this.synthese_loading = true
            this.synthese_error = ''
            try {
                const credential = await consultationApi.getTableauMedecinAccess()
                const token = credential && credential.data && credential.data.access_token
                if (!credential || !credential.success || !token) throw new Error('Accès médecin indisponible.')
                const response = await consultationApi.genererSyntheseIa({
                    consultation_id: this.consultation_id,
                    evolution_id: this.evolution_id,
                    contenu: String(editor.value)
                }, token)
                if (!response || !response.success || !response.synthese) throw new Error('Aucun texte généré.')
                editor.value = response.synthese.split(/\n\s*\n/).map(paragraphe => '<p>' + this.escapeHtml(paragraphe).replace(/\n/g, '<br>') + '</p>').join('')
                return true
            } catch (error) {
                this.synthese_error = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : (error && error.message) || 'La génération IA est indisponible. Vous pouvez continuer manuellement.'
                return false
            } finally {
                this.synthese_loading = false
            }
        },
        focusOccurenceSearch(index) {
            this.$nextTick(() => {
                const target = this.$refs['occurence_search_' + index]
                const input = Array.isArray(target) ? target[0] : target
                if (input) input.focus()
            })
        },
        getListeAdmissions() {
            this.type_admissions = []
            this.adm_is_loading = true
            this.$store.dispatch("getListeTypeAdmission", 'admission').then((response) => {
                this.type_admissions = response;

                if (response.length === 0) {
                    this.is_empty = true;
                } else {
                    this.is_empty = false;
                }
                this.adm_is_loading = false;
            })
        },

        async initFields() {
            this.err_message = ''
            if (this.recognition) this.stopRecording()
            this.synthese_source_date = ''
            this.synthese_initiale = ''
            this.section_data = {
                v_model: []
            }
            this.can_show_micro = []
            this.tables_by_field = {}
            this.is_loading = true
            let value  = ''
            let i = 0
            await this.liste_champs.forEach(c => {
                if (c.occurences.length > 0) {
                    value = []      // Array to hold multiple values
                } else {
                    value = ''      // Single value
                }
                this.section_data.v_model.push(
                    { value: value, field_name: c.champ, type: c.type_champ }
                );
                this.o_occurence.push('')
                this.selected_champ.push({selected_champ_occurences: []})

                if (c.type_champ == 'Editeur de texte') {
                    this.can_show_micro[i] = true
                    this.$set(this.tables_by_field, i, [])
                }
                
                if (i == (this.liste_champs.length - 1)) {
                    this.is_loading = false
                }
                i++
            });
            if (this.group_id > 0 && Array.isArray(this.selected_content)) {
                this.section_data.v_model.forEach(field => {
                    const saved = this.selected_content.find(item => item.field_name === field.field_name)
                    if (saved) field.value = saved.value
                })
            }
            if (this.isKineSection) {
                let now = ''
                try { now = clinicNow(new Date(), this.kineContext.fuseau) } catch (_) { /* Le formulaire affiche le fuseau manquant et bloque l’écriture. */ }
                this.section_data.v_model = initializeKineFields(this.slug, this.section_data.v_model, this.group_id > 0 ? this.selected_content : [], now)
            }
            this.is_loading = false
            if (this.slug === 'synthese_consultation') this.chargerBrouillonSynthese()
        },

        async chargerBrouillonSynthese(remplacer = false) {
            if (this.synthese_loading) return false
            const editor = this.section_data.v_model.find(field => field.type === 'Editeur de texte')
            if (!editor) return false
            if (remplacer && editor.value && editor.value !== this.synthese_initiale &&
                !window.confirm('Remplacer le texte actuel par une synthèse mise à jour depuis le dossier ? Vos modifications non enregistrées seront perdues.')) return false
            const valeurAvantChargement = editor.value
            this.synthese_loading = true
            this.synthese_error = ''
            try {
                const historiques = await historiqueApi.getListeHistoriqueConsultation({
                    consultation_id: this.consultation_id,
                    evolution_id: this.evolution_id,
                    filter_options: { section: '', order: '', from_date: '', to_date: '', one_date: '' }
                })
                const contenu = synthese_redigee(Array.isArray(historiques) ? historiques : [], {
                    patient: this.patient, consultation: this.consultation
                })
                this.synthese_source_date = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                // A late response must never erase text typed while the dossier was loading.
                if (editor.value !== valeurAvantChargement) return false
                if (contenu && (remplacer || !editor.value)) {
                    editor.value = contenu
                    this.synthese_initiale = contenu
                }
                return Boolean(contenu)
            } catch (error) {
                this.synthese_error = 'Le brouillon automatique est indisponible ; vous pouvez rédiger la synthèse manuellement.'
                return false
            } finally {
                this.synthese_loading = false
            }
        },

        setVmodel(response) {
            this.section_data.v_model[response.c_index].value = response.u_file
        },

        addToOccurence_o(value, index) {
            this.o_occurence[index] = this.o_occurence[index].replace('_', '')

            this.filtered_occurence[index] = [];
            
            if (value.length >= 2) {
                this.liste_occurences.forEach(
                    el => {
                        if (el.occurence.toLowerCase().includes(value.toLowerCase())) {
                            this.filtered_occurence[index].push(el)
                        }
                    }
                )
            }
        },

        /**
         * Add a new occurence to the selected champ
         * @param {*} index 
         * @param {*} value 
         */
        addNewOccurence(index, value) {
            let j = 0

            let tmp_occurence = value

            // Verify if the occurence already exists
            this.selected_champ[index].selected_champ_occurences.forEach(occurence => {
                if (occurence.toLowerCase() == value.toLowerCase()) {
                    j++
                }
            });
            if (j == 0) {
                this.selected_champ[index].selected_champ_occurences.push(tmp_occurence)
                this.section_data.v_model[index].value.push(tmp_occurence)
                this.o_occurence[index] = ''
            }
            this.filtered_occurence[index] = []
            this.focusOccurenceSearch(index)
        },

        /**
         * Add an existing occurence to the selected champ
         * @param {*} data 
         * @param {*} index 
         */
        addExistingOccurence(data, index) {
            let j = 0

            let tmp_occurence = ""
            this.liste_occurences.forEach(el => {
                if (data.occurence == el.occurence) {
                    tmp_occurence = el.occurence
                }
            });

            // Verify if the occurence already exists
            this.selected_champ[index].selected_champ_occurences.forEach(occurence => {
                if (occurence == data.occurence.toLowerCase()) {
                    j++
                }
            });

            if (j == 0) {
                this.selected_champ[index].selected_champ_occurences.push(tmp_occurence)
                this.section_data.v_model[index].value.push(tmp_occurence)
                this.o_occurence[index] = ''
            }

            this.filtered_occurence[index] = []
            this.focusOccurenceSearch(index)
        },

        /**
         * Remove an occurence from the selected champ
         * @param {*} c_index 
         * @param {*} removal_index 
         */
        removeOccurence(c_index, removal_index) {
            this.selected_champ[c_index].selected_champ_occurences.splice(removal_index, 1)
            this.section_data.v_model[c_index].value.splice(removal_index, 1)
            this.focusOccurenceSearch(c_index)
        },

        saveData() {
            if (this.save_loading || this.is_loading) return
            if (this.isKineSection && this.$refs.kineFields && (this.$refs.kineFields.loading || !this.$refs.kineFields.validate())) return
            this.err_message = ''
            if (this.is_listening) this.stopRecording()
            this.permission_is_denied = false
            this.is_error = false

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: JSON.stringify(this.info_user),
                data_type: this.slug,
            }
            

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.section_data.v_model.forEach((champ, index) => {
                if (champ.value instanceof File) {
                    form_data.append(champ.field_name, champ.value);
                } else {    
                    const tables = this.tables_by_field[index] || []
                    const value = tables.length
                        ? String(champ.value || '') + tables.map(this.tableToHtml).join('')
                        : champ.value
                    form_data.append(`champs[${index}]`, JSON.stringify({ ...champ, value }));
                }
            });
            
            this.save_loading = true

            const enregistrement = this.enregistrer_rubrique
                ? this.enregistrer_rubrique(form_data)
                : store_fiche.saveCustomSectionData(form_data)
            return enregistrement.then((response) => {
                
                if (response.success) {
                    this.$refs.mdl_section_form.click()
                    this.$emit('emitRefreshSection')
                    this.successToast(response.message)

                    this.section_data = {
                        v_model: []
                    },

                    this.selected_champ = []
                } else {
                    this.errorToast(response.message)
                }
                this.save_loading = false
            }).catch((error) => {
                this.save_loading = false
                if (this.isKineSection) {
                    this.err_message = (error.response && error.response.data && error.response.data.message) || 'Enregistrement impossible. Vos saisies sont conservées ; réessayez.'
                    return
                }
                if (!this.enregistrer_rubrique) this.$refs.mdl_section_form.click()
                const message = error && error.response && error.response.data && error.response.data.message || error.message
                this.errorToast(message || 'Connexion impossible.')
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerSection(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            store_fiche.deleteFicheSectionContent(this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit("emitRefreshSection")

                    this.$refs.del_grp_sect.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        escapeHtml(value) {
            return String(value || '').replace(/[&<>"']/g, char => ({
                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
            })[char])
        },

        addTable(index) {
            const rows = [
                ['', '', ''],
                ['', '', ''],
                ['', '', '']
            ]
            this.tables_by_field[index].push({ rows })
        },

        addTableRow(index, tableIndex) {
            const table = this.tables_by_field[index][tableIndex]
            table.rows.push(Array(table.rows[0].length).fill(''))
        },

        removeTableRow(index, tableIndex) {
            const table = this.tables_by_field[index][tableIndex]
            if (table.rows.length > 2) table.rows.pop()
        },

        addTableColumn(index, tableIndex) {
            this.tables_by_field[index][tableIndex].rows.forEach(row => row.push(''))
        },

        removeTableColumn(index, tableIndex) {
            const table = this.tables_by_field[index][tableIndex]
            if (table.rows[0].length > 1) table.rows.forEach(row => row.pop())
        },

        tableToHtml(table) {
            const header = table.rows[0].map(cell => `<th style="border:1px solid #b9c9ee;padding:8px;background:#eef3ff;text-align:left">${this.escapeHtml(cell)}</th>`).join('')
            const body = table.rows.slice(1).map(row => `<tr>${row.map(cell => `<td style="border:1px solid #b9c9ee;padding:8px">${this.escapeHtml(cell)}</td>`).join('')}</tr>`).join('')
            return `<table style="width:100%;border-collapse:collapse;margin:12px 0"><thead><tr>${header}</tr></thead><tbody>${body}</tbody></table>`
        },

        getQuill(index) {
            const editor = this.$refs[`rich_editor_${index}`]
            const instance = Array.isArray(editor) ? editor[0] : editor
            return instance ? instance.quill : null
        },

        async recordSpeech(input_selector, index) {
            this.recognition_err_msg = ''
            const quill = this.getQuill(index)
            if (quill) quill.focus()

            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                this.recognition_err_msg = 'La dictée vocale n’est pas disponible dans ce navigateur. Vous pouvez continuer au clavier.'
                return
            }
            // Browser speech recognition may otherwise send patient audio to a remote vendor.
            if (typeof SpeechRecognition.available !== 'function' ||
                typeof SpeechRecognition.install !== 'function') {
                this.recognition_err_msg = 'La dictée locale n’est pas disponible dans ce navigateur. Aucun audio du dossier n’a été transmis.'
                return
            }
            const tentative = ++this.dictee_tentative
            const options = { langs: ['fr-FR'], processLocally: true }
            try {
                let disponibilite = await SpeechRecognition.available(options)
                if (disponibilite === 'downloadable' || disponibilite === 'downloading') {
                    this.recognition_err_msg = 'Installation du module de dictée française sur cet appareil…'
                    const installe = await SpeechRecognition.install(options)
                    disponibilite = installe ? 'available' : 'unavailable'
                }
                if (tentative !== this.dictee_tentative) return
                if (disponibilite !== 'available') {
                    this.recognition_err_msg = 'La dictée française locale est indisponible sur cet appareil. Aucun audio n’a été transmis.'
                    return
                }
            } catch (_) {
                if (tentative === this.dictee_tentative) {
                    this.recognition_err_msg = 'Impossible d’activer la dictée locale. Vérifiez les autorisations du navigateur.'
                }
                return
            }
            this.can_show_micro = this.liste_champs.map((c, j) => c.type_champ === 'Editeur de texte' && j === index)
            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'
            this.recognition.processLocally = true
            this.recognition.onend = () => {
                this.is_listening = false
                this.active_dictation_index = null
                this.transcript = ''
                this.can_show_micro = this.liste_champs.map(c => c.type_champ === 'Editeur de texte')
            }

            this.recognition.onresult = (evt) => {
                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.transcript = evt.results[i][0].transcript
                    if (evt.results[i].isFinal) {
                        const text = this.transcript.trim() + ' '
                        this.transcript = ''
                        const activeQuill = this.getQuill(index)
                        if (activeQuill) {
                            const cursor = activeQuill.getSelection()
                            const position = cursor ? cursor.index : Math.max(0, activeQuill.getLength() - 1)
                            activeQuill.insertText(position, text, 'user')
                            activeQuill.setSelection(position + text.length, 0, 'silent')
                        } else {
                            this.section_data.v_model[index].value += this.escapeHtml(text)
                        }
                    }
                }
            }

            this.recognition.onerror = event => {
                const erreurs = {
                    'not-allowed': 'Accès au microphone refusé. Autorisez le microphone dans le navigateur.',
                    'audio-capture': 'Aucun microphone utilisable n’a été détecté.',
                    'language-not-supported': 'Le module local de dictée française n’est pas installé.',
                    'no-speech': 'Aucune parole détectée. Relancez la dictée lorsque vous êtes prêt.'
                }
                this.recognition_err_msg = erreurs[event.error] || 'La dictée locale s’est interrompue. Réessayez ou continuez au clavier.'
                this.is_listening = false
            }
            try {
                this.recognition.start()
                this.recognition_err_msg = ''
                this.is_listening = true
                this.active_dictation_index = index
            } catch (_) {
                this.recognition_err_msg = 'Impossible de démarrer la dictée. Vérifiez l’autorisation du microphone.'
                this.can_show_micro = this.liste_champs.map(c => c.type_champ === 'Editeur de texte')
            }
        },

        stopRecording() {
            this.dictee_tentative++
            if (this.recognition && this.is_listening) this.recognition.stop();
            this.is_listening = false;
            this.active_dictation_index = null
        
            this.can_show_micro = this.liste_champs.map(c => c.type_champ === 'Editeur de texte')
            this.transcript = ""; 
        }
    }
}
